<p-sidebar
  [(visible)]="isShow"
  (visibleChange)="isShowChange.emit(isShow)"
  styleClass="notification-sidebar"
  [position]="position"
  [blockScroll]="true">
  <ng-template pTemplate="header"> </ng-template>
  <ng-template pTemplate="content">
    <div class="flex align-items-center justify-content-between py-2">
      <p-selectButton
        [options]="informerTypeOptions"
        [(ngModel)]="selectedInformerType">
        <ng-template let-item>
          <i [class]="item.icon"></i>
          <span class="w-6rem ml-2">{{ item.label }}</span>
        </ng-template>
      </p-selectButton>

      <button
        pButton
        type="button"
        icon="pi pi-refresh"
        class="p-button-rounded p-button-text mx-1"
        (click)="notificationRef.loadNotifications()"></button>
    </div>

    <div
      *ngIf="selectedInformerType === NotificationKindEnum.PERSONAL"
      class="mt-4">
      <crm-lk-eu-notification-list [informerType]="NotificationKindEnum.PERSONAL"></crm-lk-eu-notification-list>
    </div>

    <div
      *ngIf="selectedInformerType === NotificationKindEnum.HELPDESK"
      class="mt-4">
      <crm-lk-eu-notification-list [informerType]="NotificationKindEnum.HELPDESK"></crm-lk-eu-notification-list>
    </div>
  </ng-template>
</p-sidebar>
